<template>
  <v-card class="align-stretch" height="100%">

    <v-card-title>History</v-card-title>

    <v-card-text>

      <v-data-table :loading="getCreditControlHistoryLoading" :headers="headers" :items="getCreditControlHistory.logs" :server-items-length="getCreditControlHistory.config.paginationCount" :page.sync="getCreditControlHistory.config.paginationPage" :options.sync="options" :footer-props="{itemsPerPageOptions: itemsPerPageOptions}" class="body--text">
        
        <template v-slot:item.created="{ item }">
          <span>{{ item.created | formatDate('YYYY-MM-DD HH:mm') }}</span>       
        </template>

        <template v-slot:item.previous_state="{ item }">
          <span>{{ item.previous_state | getPlaceholder }}</span>
        </template>

      </v-data-table>

    </v-card-text>

  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    data() {
      return {
        headers: [
          {text: 'Timestamp', align: 'left', sortable: false, value: 'created'},
          {text: 'Attribute', align: 'left', sortable: false, value: 'attribute_changed'},
          {text: 'Previous Value', align: 'left', sortable: false, value: 'previous_state'},
          {text: 'New Value', align: 'left', sortable: false, value: 'current_state'},
          {text: 'User', align: 'left', sortable: false, value: 'user'},
        ],
        options: {
          itemsPerPage: 10,
          page: 1
        },
        itemsPerPageOptions: [5,10,25,50]
      }
    },

    computed: {
      ...mapGetters('creditControl', ['getCreditControlHistory', 'getCreditControlHistoryLoading'])
    },

    watch: {
      options: {
        immediate: false,
        handler() {
          this.updateCreditControlHistoryPagination({ account_id: this.$route.params.id, options: this.options });
        },
        deep: true
      }
    },
    
    filters: {
      getPlaceholder(item) {
        if (item === 'None') {
          return '';
        }
        return item;
      }
    },

    methods: {
      ...mapActions('creditControl', ['updateCreditControlHistoryPagination']),     
    }
  }
</script>

<style lang="scss" scoped>
</style>